// extracted by mini-css-extract-plugin
module.exports = {"optionalCheckBox":"styles_optionalCheckBox__2CGma"};